import { render } from "./CouponUser.vue?vue&type=template&id=bc27964e&scoped=true"
import script from "./CouponUser.vue?vue&type=script&lang=js"
export * from "./CouponUser.vue?vue&type=script&lang=js"

import "./CouponUser.vue?vue&type=style&index=0&id=bc27964e&scoped=true&lang=css"

import exportComponent from "D:\\code\\tea-web\\tea-web\\tea-vue\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bc27964e"]])

export default __exports__